import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faPlus } from "@fortawesome/pro-solid-svg-icons";
import ChatListItem from "app/modules/aiAssistant/page/chatsList/components/ChatListItem";
import {
  selectChats,
  selectCurrentChatSessionID,
  selectLoadingChats,
  startNewChat,
} from "app/modules/aiAssistant/AIAssistantSlice";
import { filterChatsByName, groupChatsByDate } from "app/modules/aiAssistant/page/chatsList/helpers/chatsListHelpers";
import { ASSISTIMO_ICON_SRC } from "app/modules/aiAssistant/shared/constants";
import { ASSISTIMO_ROUTE } from "app/modules/aiAssistant/shared/assistimoRoutes";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import "app/modules/aiAssistant/styles/shared.scss";
import "./ChatsList.scss";

const ChatsList = () => {
  const chats = useSelector(selectChats);
  const currentChatSessionID = useSelector(selectCurrentChatSessionID);
  const loadingChats = useSelector(selectLoadingChats);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const chatGroups = useMemo(() => groupChatsByDate(filterChatsByName(chats, search)), [chats, search]);

  return (
    <aside className="assistimo-panel assistimo-chat-list" aria-label="Chat history">
      <div className="assistimo-chat-list__header">
        <div className="assistimo-brand">
          <img src={ASSISTIMO_ICON_SRC} alt="" />
          <span>Assistimo</span>
        </div>
        <button
          data-test-id="assistimo-chats-list__new-chat-button"
          type="button"
          className="assistimo-button assistimo-button--primary"
          onClick={() => {
            dispatch(startNewChat());
            navigate(ASSISTIMO_ROUTE, { replace: true });
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
          New chat
        </button>
        <label className="assistimo-chat-search">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <input
            data-test-id="assistimo-chats-list__search-input"
            type="search"
            className="assistimo-chat-search__input"
            placeholder="Search chats"
            aria-label="Search chats"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </label>
      </div>
      <div className="assistimo-chat-list__groups">
        {loadingChats && chats.length === 0 ? (
          <div className="assistimo-chat-list__empty">
            <ClipLoader size={40} color="currentColor" className="assistimo-spinner" />
          </div>
        ) : chatGroups.length === 0 ? (
          <div className="assistimo-chat-list__empty">
            {search.trim() ? "No chats match your search" : "No chats yet"}
          </div>
        ) : (
          chatGroups.map((group, index) => (
            <div key={group.label} className="assistimo-chat-list__group">
              <h2 id={`assistimo-chat-group-${index}`} className="assistimo-chat-list__group-label">
                {group.label}
              </h2>
              <ul className="assistimo-chat-list__items" aria-labelledby={`assistimo-chat-group-${index}`}>
                {group.chats.map((chat) => (
                  <ChatListItem
                    key={chat.chatSessionID}
                    chat={chat}
                    isActive={chat.chatSessionID === currentChatSessionID}
                  />
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
    </aside>
  );
};

export default ChatsList;
